<template>
  <div v-if="!capacityExceededWarningConfig.show">
    <DateAndPeople
      ref="dateAndPeople"
      class="mb-4"
      :title-visible="false"
      @track="track"
    />

    <EnquiryPricingTable />

    <BaseButton
      :is-loading="$store.state.isLoading.sendEnquiry"
      color="red"
      size="large"
      class="w-full mb-4 flex items-center justify-center"
      data-test-id="enquiry-form__date-and-ppl-btn"
      @click="submit"
    >
      {{ $store.getters.cta.firstStep }}
    </BaseButton>

    <div
      v-if="$store.getters.isRtbFlowPossible"
      class="text-grey-600 text-xs flex items-center justify-center mt-2"
    >
      You won't be charged yet
    </div>
  </div>

  <CapacityExceededWarning
    v-else
    class="mt-6"
    :people="capacityExceededWarningConfig.people"
    @back="capacityExceededWarningConfig.show = false"
    @continue="enquireAnyway"
  />
</template>

<script>
import { mapState } from 'vuex';

import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';
import CapacityExceededWarning from '@/modules/public/enquiry-form/components/EnquiryForm/components/CapacityExceeded/CapacityExceededWarning.vue';
import DateAndPeople from '@/modules/public/enquiry-form/components/EnquiryForm/forms/DateAndPeople.vue';
import EnquiryPricingTable from '@/modules/public/enquiry-form/components/EnquiryPricingTable.vue';
import { setContextParam } from '@/services/context-store.js';

export default {
  name: 'StepDateAndPeople',
  emits: ['submit'],
  components: {
    EnquiryPricingTable,
    BaseButton,
    CapacityExceededWarning,
    DateAndPeople,
  },

  data() {
    return {
      capacityExceededWarningConfig: {
        show: false,
        people: null,
      },
    };
  },

  computed: {
    ...mapState([
      'form',
      'pages',
      'room',
    ]),
  },

  methods: {
    submit() {
      this.trackSubmitBtnClicked();

      const { isValid, data } = this.$refs.dateAndPeople.submit();
      if (!isValid) {
        return;
      }

      const people = parseInt(data.people.value, 10);
      const isOverPeopleLimit = people > this.room.capacity.max;
      const isBelowMinCapacity = !this.$store.getters.isRtbFlowPossible && this.room.capacity?.min > 1 && people < this.room.capacity.min;
      if (isOverPeopleLimit || isBelowMinCapacity) {
        this.capacityExceededWarningConfig = {
          show: true,
          people,
        };
      } else {
        this.finishSubmit();
      }

      const element = this.$store.getters.isRtbFlowPossible ? 'request_to_book_button' : 'enquire_now_button';
      this.$store.dispatch('trackGA4Interaction', {
        section: 'event_info',
        element,
        interaction: 'click',
      });
    },
    trackSubmitBtnClicked() {
      setContextParam('UserCabinet', 'room_page');

      const label = this.$store.getters.isRtbFlowPossible ? 'enquire-now-request-to-book' : 'enquire-now';
      this.$store.dispatch('trackEnquiryFormNavigation', {
        label,
      });
    },
    enquireAnyway() {
      this.$store.dispatch('trackEnquiryFormNavigation', {
        label: 'enquire-anyway',
      });
      this.finishSubmit();
    },

    finishSubmit() {
      this.$emit('submit', {
        requestToBookPath: true,
      });
    },
    track({ element, interaction, value = null }) {
      const actionName = 'trackGA4Interaction';
      const section = 'event_info';

      this.$store.dispatch(actionName, {
        section,
        element,
        interaction,
        value,
      });
    },
  },
};
</script>
